module.exports = __webpack_public_path__ + "img/mastercard-logo.46e33ffd.svg";